import { polyfill } from "es6-promise";
import fetch from "isomorphic-fetch";

class BackendAPI {
  constructor() {
    // needed for IE
    polyfill();
  }

  validateStatusCode(response) {
    if (response.ok) {
      return Promise.resolve(response);
    }

    return response.json().then(err => Promise.reject(err));
  }

  // TODO: create get, put, post functions
  request(method, path, body) {
    const headers = {
      Accept: "application/json",
      "Content-type": "application/json",
    };
    var headersPromise;
    if (typeof RLAuth !== 'undefined') {
      headersPromise = RLAuth.amendHeaders(headers);
    } else {
      headersPromise = Promise.resolve(headers);
    }

    return headersPromise.then(headers => {
          return fetch(path, {
            headers,
            method,
            credentials: "include",
            body: JSON.stringify(body)
          });
      })
      .then(response => this.validateStatusCode(response))
      .then(response => response.json());
  }
}

export default BackendAPI;
